import { FC, useReducer } from 'react';
import { SupportForm } from './SupportForm';
import { SupportHeader } from './SupportHeader';
import { SupportSuccessModal } from './modals/SupportSuccessModal';

export const SupportPage: FC = () => {
  const handleRequestSent = () => {
    toggleModalOpen();
  };

  const [isModalOpen, toggleModalOpen] = useReducer((state) => !state, false);

  return (
    <>
      <div className='bg-wave flex h-screen w-screen items-center justify-center'>
        <div className='flex h-[31.25rem] w-auto flex-col gap-5 rounded-lg bg-[url("/assets/image/bg-support-modal.svg")] bg-cover bg-[50px_45px] bg-no-repeat px-4 py-6 shadow-lg sm:w-[560px] sm:bg-[200px_45px] sm:p-6'>
          <SupportHeader />
          <SupportForm onConfirm={handleRequestSent} />
        </div>
      </div>
      {isModalOpen && <SupportSuccessModal onConfirm={async () => toggleModalOpen()} onClose={toggleModalOpen} />}
    </>
  );
};
